import { httpRequest } from "@services/http";
import type { Role } from "./cmdListRoles";

export class CommandCreateRole {
  async run(payload: { name: string }): Promise<Role> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/roles/`;
    try {
      return await httpRequest<Role>(url, { method: "POST", body: payload });
    } catch (error) {
      console.error("Error creating role:", error);
      throw error;
    }
  }
}
